export default {
  bgMusic: 'BGM',
  bgImage: 'Background Image',
  bgColor: 'Background Color',
  defaultLanguage: 'Default Language',
  colorChoose:
    'When the background color and the background image exist at the same time, the background color is displayed first.',
  languageChoose:
    'If the languages of the playable does not match the language of your device, this default language will be applied.',
  bgmTipsContent: 'Support MP3 format, the size does not exceed 2M',
  bgImgTipsContent: 'Support PNG/JPG format',
  tip: 'Tip',
  orNotDeleteBgImg: 'Whether to delete the background image',
  cancelBtn: 'Cancel',
  confirmBtn: 'Confirm',
  gameLoadMessage: "Game hasn't loaded yet",
  bgColorMessage:
    'The background color that has been set cannot replace the background image, please delete the background color first',
  cancelDelete: 'Undeleted',
  deleteSuccess: 'Successfully Deleted!',
  uploadSuccess: 'Upload Completed!',
  addBgmWarning:
    'No background sound effects have been added, please add first',
  orNotDeleteBgm: 'Whether to delete background sound effects',
  backgroundAudio: {
    replaceBtn: 'Replace',
    cutterBtn: 'Clip',
    volume: 'Volume',
    bgmInfoDuration: 'Acquiring...',
    fileSizeMessage: 'Background music cannot exceed 2M',
    fileExtMessage: 'Only upload audio in mp3 format',
  },
  backgroundImage: {
    uploadBtn: 'Replace',
    cropBtn: 'Clip',
    filter: 'Filter',
    cropSuccess: 'Cropping is complete!',
    filterSuccess: 'Filter modification completed',
  },
  backgroundColor: {
    single: 'Solid',
    gradient: 'Gradient',
    toggleMessage: 'The game is not loaded',
  },
  language: {
    editBtn: 'Language to Modify',
    deleteBtn: 'Delete Language',
    addBtn: 'Add Language',
    deleteConfirm: 'Confirm deletion?',
    dialog: {
      addLanguage: 'Add Language',
      selectLanguage: 'Language',
      closeBtn: 'Cancel',
      submitBtn: 'Submit',
      contentNotEmpty: 'Please select language',
    },
  },
  tabBarList: {
    design: 'Exterior',
    animation: 'Animation',
    scene: 'Scene setting',
    global: 'Global settings',
    event: 'Event',
    gameConfig: 'Gameplay Parameters',
  },
}
